module.exports = __webpack_public_path__ + "img/02.bc276361.jpg";